import { Field, Form as FormFormik, Formik } from 'formik';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import {
  editCollabData,
  getCollabById /* , editProfile */
} from 'redux/colabsSlice';
import MyButtonSpinner from 'components/common/my-components/MyButtonSpinner';
import { userUpdateSchema } from '../validations/userUpdateSchema';

export const UserUpdateForm = ({ user }) => {
  const dispatch = useDispatch();
  const [loadingButton, setLoadingButton] = useState(false);

  const handleSubmit = async values => {
    if (loadingButton) {
      return null;
    } else {
      setLoadingButton(true);

      let userData = {
        firstName: values.firstName,
        lastName: values.lastName,
        email: values.email,
        phoneNumber: values.phoneNumber,
        dni: values.dni
      };

      const response = await dispatch(editCollabData(user.id, userData));
      //editProfile //para el collab
      if (response?.status < 400) {
        dispatch(getCollabById(user.id));
      }
    }
    setLoadingButton(false);
  };

  return (
    <Formik
      initialValues={{
        firstName: user?.firstName || '',
        lastName: user?.lastName || '',
        email: user?.email || '',
        dni: user?.dni || '',
        phoneNumber: user?.phoneNumber || ''
      }}
      validationSchema={userUpdateSchema}
      onSubmit={handleSubmit}
    >
      {({ errors, touched, setValues }) => {
        useEffect(() => {
          setValues({
            firstName: user?.firstName || '',
            lastName: user?.lastName || '',
            email: user?.email || '',
            dni: user?.dni || '',
            phoneNumber: user?.phoneNumber || ''
          });
        }, [user]);
        return (
          <FormFormik>
            <Row className="g-3">
              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Nombre</small>
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="firstName"
                  type="text"
                  placeholder="Ingresa tu nombre"
                  isInvalid={errors.firstName && touched.firstName}
                />

                {errors.firstName && touched.firstName ? (
                  <p className="text-danger small m-0">{errors.firstName}</p>
                ) : null}
              </Col>

              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Apellido</small>
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="lastName"
                  type="text"
                  placeholder="Ingresa tu apellido"
                  isInvalid={errors.lastName && touched.lastName}
                />

                {errors.lastName && touched.lastName ? (
                  <p className="text-danger small m-0">{errors.lastName}</p>
                ) : null}
              </Col>

              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>DNI</small>
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="dni"
                  type="number"
                  placeholder="Ingresa tu DNI"
                  isInvalid={errors.dni && touched.dni}
                />

                {errors.dni && touched.dni ? (
                  <p className="text-danger small m-0">{errors.dni}</p>
                ) : null}
              </Col>

              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Teléfono</small>
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="phoneNumber"
                  type="number"
                  placeholder="Ingresa tu teléfono"
                  isInvalid={errors.phoneNumber && touched.phoneNumber}
                />

                {errors.phoneNumber && touched.phoneNumber ? (
                  <p className="text-danger small m-0">{errors.phoneNumber}</p>
                ) : null}
              </Col>

              <Col as={Form.Group} xs={12}>
                <Form.Label>
                  <small>Email</small>
                </Form.Label>
                <Form.Control
                  as={Field}
                  name="email"
                  type="email"
                  placeholder="Ingresa tu email"
                  isInvalid={errors.email && touched.email}
                />

                {errors.email && touched.email ? (
                  <p className="text-danger small m-0">{errors.email}</p>
                ) : null}
              </Col>

              <Col xs={12}>
                {!loadingButton ? (
                  <Button
                    variant="primary"
                    type="submit"
                    className="w-100"
                    disabled={
                      !!errors.firstName ||
                      !!errors.lastName ||
                      !!errors.email ||
                      !!errors.dni ||
                      !!errors.phoneNumber ||
                      loadingButton
                    }
                  >
                    Actualizar Usuario
                  </Button>
                ) : (
                  <MyButtonSpinner className="w-100" />
                )}
              </Col>
            </Row>
          </FormFormik>
        );
      }}
    </Formik>
  );
};

UserUpdateForm.propTypes = {
  user: PropTypes.object
};
